import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';
import {APP_PERMISSIONS} from '../../../data/permissions';

export const navConfig = (id?: string) => [
  {
    icon: 'mobile-learning-menu.svg',
    title: getLocalizationBasedOnLang('Mobile learning', 'Dysgu symudol'),
    route: `/manage/${id}/home`,
    slug: 'mobile-learning',
    activeIcon: 'mobile-learning-menu.svg',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_ACCESS_LIBRARY,
    items: [
      {
        icon: 'microreel-menu.svg',
        title: getLocalizationBasedOnLang('Studio', 'Studio'),
        route: `/manage/${id}/microreels/studio`,
        slug: 'microreel-studio',
        badge: getLocalizationBasedOnLang('(Beta)', '(Beta)'),
        activeIcon: 'microreel-menu.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_EDIT_COURSES,
      },
      {
        icon: 'microreel-menu.svg',
        title: getLocalizationBasedOnLang('Microreels', 'Microreels'),
        route: `/manage/${id}/microreels`,
        slug: 'microreels',
        activeIcon: 'microreel-menu.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_CREATE_COURSES,
      },
      {
        icon: 'posts-menu.svg',
        title: getLocalizationBasedOnLang('Posts', 'Posts'),
        route: `/manage/${id}/posts`,
        slug: 'posts',
        activeIcon: 'posts-menu.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_CREATE_COURSES,
      },
      {
        icon: 'feedback-menu.svg',
        title: getLocalizationBasedOnLang('Feedback', 'Adborth'),
        route: `/manage/${id}/feedback_questions`,
        slug: 'feedback',
        activeIcon: 'feedback-menu.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_LIST_COURSES,
      },
    ],
  },
  {
    icon: 'desktop-learning-menu.svg',
    title: getLocalizationBasedOnLang('Desktop learning', 'Dysgu bwrdd gwaith'),
    route: `/manage/${id}/desktop_learning`,
    slug: 'desktop-learning',
    activeIcon: 'desktop-learning-menu.svg',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_ACCESS_LIBRARY,
    items: [
      {
        icon: 'microlesson-menu.svg',
        title: getLocalizationBasedOnLang('Microlessons', 'Microlessons'),
        route: `/manage/${id}/microlessons`,
        slug: 'microlessons',
        activeIcon: 'microlesson-menu.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_CREATE_COURSES,
      },
      {
        icon: 'video-generation-menu.svg',
        title: getLocalizationBasedOnLang(
          'Video generation',
          'Cynhyrchu fideo',
        ),
        route: `/manage/${id}/home/generate_video`,
        slug: 'video-generation',
        activeIcon: 'video-generation-menu.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_ACCESS_LIBRARY,
      },
      {
        icon: 'ai-assistant.svg',
        title: getLocalizationBasedOnLang('AI assistance', 'Cymorth AI'),
        route: `/manage/${id}/ai_assistant`,
        slug: 'ai-assistance',
        activeIcon: 'ai-assistant.svg',
        reqireSubscription: true,
        permission: APP_PERMISSIONS.ORG_CREATE_COURSES,
      },
    ],
  },
  {
    icon: 'projects-menu.svg',
    title: getLocalizationBasedOnLang('Projects', 'Prosiectau'),
    route: `/manage/${id}/projects`,
    slug: 'projects',
    activeIcon: 'projects-menu.svg',
    permission: APP_PERMISSIONS.ORG_CREATE_COURSES,
    reqireSubscription: true,
  },
  {
    icon: 'course-menu.svg',
    title: getLocalizationBasedOnLang('Courses', 'Cyrsiau'),
    route: `/manage/${id}/courses`,
    slug: 'courses',
    activeIcon: 'course-menu.svg',
    permission: APP_PERMISSIONS.ORG_LIST_COURSES,
    reqireSubscription: true,
  },
  {
    icon: 'icon-users',
    title: getLocalizationBasedOnLang('Learners', 'Dysgwyr'),
    route: `/manage/${id}/learners`,
    slug: 'learners',
    activeIcon: 'Users',
    permission: APP_PERMISSIONS.ORG_LIST_LEARNERS,
    reqireSubscription: true,
  },
  {
    icon: 'icon-icon_analytics',
    title: getLocalizationBasedOnLang('Analytics', 'Analytics'),
    route: `/manage/${id}/analytics`,
    slug: 'analytics',
    activeIcon: 'Analytics',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_LIST_LEARNERS,
  },
  {
    icon: 'icon-laptop',
    title: getLocalizationBasedOnLang('Library', 'Llyfrgell'),
    route: `/manage/${id}/library`,
    slug: 'nav-library',
    activeIcon: 'Page',
    permission: APP_PERMISSIONS.ORG_ACCESS_LIBRARY,
    reqireSubscription: true,
  },
  {
    icon: 'icon-settings',
    title: getLocalizationBasedOnLang('Settings', 'Gosodiadau'),
    route: `/manage/${id}/settings`,
    slug: 'settings',
    activeIcon: 'Settings',
    reqireSubscription: false,
    permission: APP_PERMISSIONS.ORG_MANAGE_SETTINGS,
  },
];

export const helpConfig = {
  icon: 'icon-mail',
  title: getLocalizationBasedOnLang('Help & tutorials', 'Cymorth a thiwtorïau'),
  route: `https://help.tapybl.com/support/home`,
  slug: 'help',
  activeIcon: 'Help',
};

export const contactConfig = {
  icon: 'icon-annotation-question',
  title: getLocalizationBasedOnLang('Contact us', 'Cysylltwch â ni'),
  route: `https://help.tapybl.com/support/tickets/new?ticket_form=ask_a_question`,
  slug: 'mail',
  activeIcon: 'Mail',
};
